import { render } from "./CopyrightView.vue?vue&type=template&id=f7c3730e"
const script = {}

import "./CopyrightView.vue?vue&type=style&index=0&id=f7c3730e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__